/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chevron-down': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 23.9L3.3 11.2l1.4-1.4L16 21.1 27.3 9.8l1.4 1.4z"/>'
  }
})
